//
import axios from 'axios'

//
import { CommissionModel, CommissionTypeModel } from '@/models'
import {
    generateFetchDataFunction,
    generateDeleteItemFunction,
} from '../DataTableService'

//
const dtFetchData = generateFetchDataFunction(CommissionModel),
    dtDeleteItem = generateDeleteItemFunction(CommissionModel)

/**
 *
 */
const create = async function(data) {
    //
    try {
        //
        let commission = new CommissionModel(data),
            response = await commission.save()

        //
        return response
    } catch (error) {
        //
        return error.response.data
    }
}

/**
 *
 */
const fetchAll = async function() {
    //
    try {
        //
        let commissions = await CommissionModel.get()

        //
        return commissions.data
    } catch (error) {
        //
        return error.response.data
    }
}

/**
 *
 */
const fetchAllTypes = async function() {
    //
    try {
        //
        let commissionstypes = await CommissionTypeModel.get()

        //
        return commissionstypes.data
    } catch (error) {
        //
        return error.response.data
    }
}

/**
 *
 */
const fetchById = async function(id) {
    //
    try {
        //
        let commission = await CommissionModel.find(id)

        //
        return commission
    } catch (error) {
        //
        return error.response.data
    }
}

/**
 *
 */
const remove = async function(id) {
    //
    try {
        let route = process.env.VUE_APP_API_ROUTE
        //
        let response = await axios.delete(`${route}/sl_commission/${id}`)
        //
        return response.data
    } catch (error) {
        //
        return error.response.data
    }
}

//
export default {
    create,
    dtDeleteItem,
    dtFetchData,
    fetchAll,
    fetchAllTypes,
    fetchById,
    remove,
}
